export default {
  'amount': 'Estimated Deposit Amount',
  'customer': 'Client Name',
  'number': 'Client Account Number',
  'children_account': 'Bank Sub-Account',
  'accountMaster': 'Eddid Securities and Futures Limited',
  'noSub': 'No record of sub-account application',
  'success': 'Your sub-account application has been successfully submitted. Please contact us if you have any questions',
  'detailsTitle': 'Bank Sub-Account Details',
  'detailsBankName': 'Bank Name',
  'detailsBankCardNumber': 'Bank Account Number',
  'detailsPayeeName': 'Payee Name',
  'detailsSwiftCode': 'SWIFT Code',
  'detailsBankAddress': 'Bank Address',
  'detailsAliasAddress': 'Bank Address - English',
  'notCHN': 'This page is not available for viewing.'
}
